export enum HallowABFlag {
  WebFirstMonthFreeText = "web_first_month_free_text",
  WebFoundingStory = "web_founding_story",
  WebMediumOnboarding = "web_medium_onboarding",
  WebHomepageCTADestination = "web_homepage_cta_destination",
  WebSubscreenArrowButton = "web_subscreen_arrow_button",
}
